import { Head, usePage } from "@inertiajs/react";
import { useMemo, useState } from "react";

import FlashDealsCTA from "@/theme2/components/flashDeals/FlashDealsCTA";
import FlashDealsGrid from "@/theme2/components/flashDeals/FlashDealsGrid";
import FlashDealsHero from "@/theme2/components/flashDeals/FlashDealsHero";
import FlashDealsTabs from "@/theme2/components/flashDeals/FlashDealsTabs";
import { flashDealsPage } from "@/theme2/data/flashDealsPage";

export default function FlashDeals() {
  const { dealProducts = [] } = usePage().props;
  const [activeTab, setActiveTab] = useState("all");

  const filteredProducts = useMemo(() => {
    if (activeTab === "all") {
      return dealProducts;
    }

    return dealProducts.filter(
      (product) => product.dealType === activeTab
    );
  }, [activeTab, dealProducts]);

  return (
    <>
      <Head title={flashDealsPage.seo.title}>
        <meta
          name="description"
          content={flashDealsPage.seo.description}
        />
      </Head>

      <main className="overflow-hidden">
        <div className="mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-8 py-5 sm:py-7 lg:py-10">
          <FlashDealsHero hero={flashDealsPage.hero} />

          <section className="py-14 sm:py-16 lg:py-20">
            <FlashDealsTabs
              tabs={flashDealsPage.tabs}
              value={activeTab}
              onChange={setActiveTab}
            />

            <div className="mt-10">
              <FlashDealsGrid products={filteredProducts} />
            </div>
          </section>

          <FlashDealsCTA content={flashDealsPage.callToAction} />
        </div>
      </main>
    </>
  );
}
